import utils from './utils';
import context from './context';

export default function calculateDateParameters(event) {
  const fullDayWithShiftedHours =
    event.fullDay && !event.dtstart.includes('00:00:00') && !event.dtend.includes('23:59:59');
  if (fullDayWithShiftedHours) {
    event.fullDay = false;
  }

  const params = {};
  const { dtstart, dtend, fullDay, fullDayDtstart, fullDayDtend } = event;

  params.dtstartTimezone = dtstart.substr(19);
  params.dtendTimezone = dtend.substr(19);
  params.dtstartOffset = Number(dtstart.substr(19, 3));
  params.dtendOffset = Number(dtend.substr(19, 3));
  params.dtstart = utils.getRealDate(dtstart);
  params.dtend = utils.getRealDate(dtend);
  params.dtstartLocal = new Date(dtstart);
  params.dtendLocal = new Date(dtend);
  params.timezoneString = getTimezoneString(params.dtstartOffset);

  if (fullDay && !fullDayDtstart && !fullDayDtend) {
    const { visibleHoursStart, visibleHoursEnd } = context.orgSettings;
    const { visibleStart: businessDtstart } = utils.getBusinessDayForCalendar(
      visibleHoursStart,
      visibleHoursEnd,
      utils.formatDate(params.dtstart)
    );
    const { visibleEnd: businessDtend } = utils.getBusinessDayForCalendar(
      visibleHoursStart,
      visibleHoursEnd,
      utils.formatDate(params.dtend)
    );

    params.fullDayDtstart = params.dtstart;
    params.dtstart = businessDtstart;
    params.fullDayDtend = params.dtend;
    params.dtend = businessDtend;
  }

  if (fullDayWithShiftedHours) {
    params.dtend = utils.addMinutes(params.dtend, 1);
  }

  return params;
}

function getTimezoneString(timezoneOffset) {
  if (timezoneOffset === 0) {
    return 'GMT';
  }

  return `GMT${timezoneOffset > 0 ? '+' : ''}${timezoneOffset}`;
}
